import { render } from "./FaceDetailDialog.vue?vue&type=template&id=16dc69f5&scoped=true&ts=true"
import script from "./FaceDetailDialog.vue?vue&type=script&lang=ts"
export * from "./FaceDetailDialog.vue?vue&type=script&lang=ts"

import "./FaceDetailDialog.vue?vue&type=style&index=0&id=16dc69f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dc69f5"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QIcon,QBtn,QSpace});
